/** 메인 앱 ↔ 프레젠 새 탭 튜토리얼 핸드오프 (원래 탭 오버레이 자동 종료) */
export const TUTORIAL_HANDOFF_CHANNEL = 'cp-tutorial-handoff';

const HANDOFF_IGNORE_KEY = 'cp-tutorial-handoff-ignore';

export type TutorialHandoffMessage = {
  type: 'tutorial-tab-handoff';
  tutorialId: string;
};

/**
 * 다른 탭에 튜토리얼 핸드오프를 알린다.
 * BroadcastChannel은 송신 탭에도 메시지가 오므로, 이 탭에서는 한 번 무시하도록 표시한다.
 */
export function broadcastTutorialTabHandoff(tutorialId: string): void {
  const id = tutorialId.trim();
  if (!id || typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') return;
  try {
    sessionStorage.setItem(HANDOFF_IGNORE_KEY, id);
  } catch {
    /* ignore */
  }
  try {
    const ch = new BroadcastChannel(TUTORIAL_HANDOFF_CHANNEL);
    const msg: TutorialHandoffMessage = { type: 'tutorial-tab-handoff', tutorialId: id };
    ch.postMessage(msg);
    ch.close();
  } catch {
    /* ignore */
  }
}

/** 이 탭에서 방금 보낸 핸드오프 신호면 true (자기 자신 종료 방지) */
export function consumeTutorialHandoffIgnore(tutorialId: string): boolean {
  const id = tutorialId.trim();
  if (!id || typeof sessionStorage === 'undefined') return false;
  try {
    if (sessionStorage.getItem(HANDOFF_IGNORE_KEY) !== id) return false;
    sessionStorage.removeItem(HANDOFF_IGNORE_KEY);
    return true;
  } catch {
    return false;
  }
}
